import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import apiClient from '../utils/api';
import { Button } from '../components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '../components/ui/dropdown-menu';
import { User, Settings, LogOut, ChevronDown, Users } from 'lucide-react';

// Team management is a paid-tier feature — only show this menu item to paid plans.
const TEAM_VISIBLE_PLANS = new Set(['starter', 'pro', 'team']);

export const UserMenu = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [planType, setPlanType] = useState('free');

  useEffect(() => {
    let cancelled = false;
    apiClient.get('/plan/current').then(res => {
      if (!cancelled) setPlanType(res.data?.plan || 'free');
    }).catch(() => {});
    return () => { cancelled = true; };
  }, []);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const firstName = user?.name?.split(' ')[0] || 'User';
  const showTeam = TEAM_VISIBLE_PLANS.has(planType);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="flex items-center gap-2" data-testid="user-menu-trigger">
          <span className="text-sm">Welcome, {firstName}</span>
          <ChevronDown className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        <DropdownMenuItem onClick={() => navigate('/profile')} data-testid="menu-profile">
          <User className="h-4 w-4 mr-2" />
          Profile
        </DropdownMenuItem>
        {showTeam && (
          <DropdownMenuItem onClick={() => navigate('/team')} data-testid="menu-team">
            <Users className="h-4 w-4 mr-2" />
            Team
          </DropdownMenuItem>
        )}
        <DropdownMenuItem onClick={() => navigate('/account-settings')} data-testid="menu-settings">
          <Settings className="h-4 w-4 mr-2" />
          Account Settings
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={handleLogout} data-testid="menu-logout">
          <LogOut className="h-4 w-4 mr-2" />
          Logout
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};